export const money = () => {
    const data = JSON.parse(localStorage.getItem('access'))
    return data.currencyPrefix
}
export const format = (amount) => parseFloat(amount).toLocaleString('es-US',{minimumFractionDigits: 2, decimalSeparator: '.'})